import { apiClient } from '../../apiClient';
import { BaseCRUDApi } from '../../baseCRUDApi';

export const API_FO_CAAN_TRUONG_PATH = "food/ca-an-truong";

/** Body của `PUT food/ca-an-truong` (FoCaAnTruongItemRequest.cs) */
export interface IFoCaAnTruongSaveRequest {
	id: number;
	fo_caan_id: number;
	ca_an: string;
	dm_truong_ids: number[];
	dm_coso_id: number;
}

export interface IFoCaAnTruongSelectByCaAnRequest {
	fo_caan_id: number;
	dm_coso_id: number;
}

class FoCaAnTruongApi extends BaseCRUDApi<IFoCaAnTruongSaveRequest> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/food/ca-an-truong`);
	}
	SelectByCaAn(request: IFoCaAnTruongSelectByCaAnRequest) {
		return apiClient.get(
			`${API_FO_CAAN_TRUONG_PATH}/select-ca-an?fo_caan_id=${request.fo_caan_id}&dm_coso_id=${request.dm_coso_id}`
		);
	}
}
export const foCaAnTruongApi = new FoCaAnTruongApi(API_FO_CAAN_TRUONG_PATH);
